import { useState } from "react";
import { Trash2, AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const OPTIONS = [
  { key: "deleteDemoSpk", title: "Hapus SPK demo (format SPK-xxxxxx-xxx)", desc: "SPK contoh lama beserta marking, STB, scan QC, delivery & riwayat label terkait." },
  { key: "resetQcDelivery", title: "Hapus riwayat scan QC & Final Check (MC)", desc: "Mengosongkan Riwayat Scan, Scan per Operator, Delivery Final dan menolkan angka QC OK / Delivery di semua marking & grafik." },
  { key: "deleteAllStb", title: "Hapus semua STB & laporan STB", desc: "Menolkan STB Final di dashboard, tagihan tidak lagi punya sumber, Qty Selesai kembali 0." },
];

/** Panel admin: pembersihan data demo/uji (konfirmasi ketik HAPUS) */
export function DataCleanup() {
  const [sel, setSel] = useState({ deleteDemoSpk: true, resetQcDelivery: false, deleteAllStb: false });
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const any = Object.values(sel).some(Boolean);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/cleanup", { ...sel, confirm });
      const parts = [];
      if (data.demoSpk) parts.push(`${data.demoSpk.spks} SPK demo, ${data.demoSpk.markings} marking, ${data.demoSpk.stbs} STB`);
      if (data.resetQcDelivery) parts.push(`${data.resetQcDelivery.scans} scan, ${data.resetQcDelivery.deliveries} delivery`);
      if (data.deleteAllStb) parts.push(`${data.deleteAllStb.stbs} STB, ${data.deleteAllStb.stbReports} laporan`);
      toast.success(`Pembersihan selesai: ${parts.join(" · ") || "tidak ada"}`);
      setConfirm("");
      setTimeout(() => window.location.reload(), 1200);
    } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
  };

  return (
    <div className="panel max-w-xl space-y-4 border-rose-500/30 p-5" data-testid="settings-cleanup-panel">
      <div>
        <div className="flex items-center gap-2 font-display text-sm font-bold text-rose-300"><AlertTriangle className="h-4 w-4" /> Pembersihan Data Demo / Uji <span className="cn text-[11px] font-normal text-slate-500">清理演示数据</span></div>
        <p className="mt-1 text-xs text-slate-500">Hapus data contoh agar dashboard hanya menampilkan data operasional nyata. Master proyek, vendor, user, Delivery List, SPK format FAB-… dan pengaturan TIDAK ikut terhapus.</p>
      </div>
      <div className="space-y-2">
        {OPTIONS.map((o) => (
          <label key={o.key} className={`flex cursor-pointer gap-3 rounded border p-3 text-xs transition-colors ${sel[o.key] ? "border-rose-500/40 bg-rose-500/5" : "border-slate-800 hover:border-slate-700"}`} data-testid={`cleanup-option-${o.key}`}>
            <input type="checkbox" checked={sel[o.key]} onChange={(e) => setSel({ ...sel, [o.key]: e.target.checked })} className="mt-0.5" data-testid={`cleanup-check-${o.key}`} />
            <span><span className="font-semibold text-slate-200">{o.title}</span><br /><span className="text-slate-500">{o.desc}</span></span>
          </label>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Ketik HAPUS" className="h-9 w-36 border-rose-500/40 bg-slate-950 font-mono text-xs uppercase" data-testid="cleanup-confirm-input" />
        <Button disabled={busy || !any || confirm.trim().toUpperCase() !== "HAPUS"} onClick={run} className="bg-rose-600 hover:bg-rose-500" data-testid="cleanup-run-button">
          {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Trash2 className="mr-1.5 h-4 w-4" />}Jalankan Pembersihan
        </Button>
      </div>
    </div>
  );
}
